import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import './HowWeWork.css';

const HowWeWork = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      number: '01',
      title: t.howWeWork.step1Title,
      description: t.howWeWork.step1Desc,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
          <circle cx="12" cy="17" r="0.5"/>
        </svg>
      )
    },
    {
      number: '02',
      title: t.howWeWork.step2Title,
      description: t.howWeWork.step2Desc,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 3v18"/>
          <path d="m8 14 4 4 4-4"/>
          <path d="M5 10h14"/>
          <path d="m8 6 4-4 4 4"/>
        </svg>
      )
    },
    {
      number: '03',
      title: t.howWeWork.step3Title,
      description: t.howWeWork.step3Desc,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
        </svg>
      )
    },
    {
      number: '04',
      title: t.howWeWork.step4Title,
      description: t.howWeWork.step4Desc,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
        </svg>
      )
    },
    {
      number: '05',
      title: t.howWeWork.step5Title,
      description: t.howWeWork.step5Desc,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
      )
    }
  ];

  return (
    <section className="how-we-work-premium" id="how-we-work">
      <div className="container">
        <div className="how-header-premium">
          <h2 className="how-main-title">{t.howWeWork.title}</h2>
          <p className="how-subtitle">{t.howWeWork.subtitle}</p>
        </div>

        <div className="timeline-premium">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`timeline-step ${activeStep === index ? 'active' : ''}`}
              onMouseEnter={() => setActiveStep(index)}
            >
              {index < steps.length - 1 && (
                <div className="step-connector-line"></div>
              )}
              
              <div className="step-content-premium">
                <div className="step-number-badge">{step.number}</div>
                <div className="step-icon-premium">{step.icon}</div>
                <h3 className="step-title-premium">{step.title}</h3>
                <p className="step-description-premium">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
